import { createFileRoute } from '@tanstack/react-router';
import { OperatorPage } from '@/features/admin/pages';

export const Route = createFileRoute('/admin/operator')({
  component: OperatorPage,
});
